import React from 'react';
import { SlidersHorizontal } from 'lucide-react';

interface FilterButtonProps {
  onOpenFilters: () => void;
  activeFiltersCount: number;
  className?: string;
}

const FilterButton: React.FC<FilterButtonProps> = ({ 
  onOpenFilters, 
  activeFiltersCount, 
  className = "" 
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onOpenFilters();
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onOpenFilters();
  };

  return (
    <button
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      className={`flex items-center justify-center gap-1.5 bg-white border-2 border-gray-900 text-gray-900 py-1.5 px-3 rounded-lg text-sm font-medium hover:bg-gray-50 active:bg-gray-100 transition-colors touch-manipulation ${className}`}
    >
      <SlidersHorizontal size={16} />
      <span>Filters</span>
      {activeFiltersCount > 0 && (
        <span className="bg-gray-900 text-white text-xs px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
          {activeFiltersCount}
        </span>
      )}
    </button>
  );
};

export default FilterButton;
